import React from "react";

const ArrowLeftRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M21.5 9L18.5 6M21.5 9L18.5 12M21.5 9H11.5M3.5 15L6.5 12M3.5 15L6.5 18M3.5 15H13.5"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ArrowLeftRight;
